import BaseSelectorV2 from "../../Common/Component/Select/BaseSelectorV2";
const DynamicCustomSelectorV2 = ({
  entitySchema = '',
  required = false,
  defaultValue,
  title = '',
  setValue = null,
  label = '_dynamicSelectValue',
  rowId = 'id',
  isMulti = false,
  showCreateButton = true,
  pathToCreate = 'select/form/:entity',
  ...props
}) => {

  const getUrl = (filterValue) => {
    return `node/crud/entity/${entitySchema}?dynamicSelectFilter=${filterValue}`;
  }

  return <BaseSelectorV2
      isMulti={isMulti}
      defaultValue={defaultValue}
      title={title}
      required={required}
      showCreateButton={showCreateButton}
      getUrl={getUrl}
      setValue={setValue}
      label={label}
      rowId={rowId}
      pathToCreate={pathToCreate}
      entity={entitySchema}
      {...props}
  />

}

export default DynamicCustomSelectorV2;
